module.exports = new __parcel__URL__("opera.219f2cfc.svg").toString();